module.exports = __webpack_public_path__ + "static/img/2.a6af7c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jlbs/2.png
// module id = k3yd
// module chunks = 0